var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{attrs:{"color":_vm.color,"elevation":"13","type":_vm.type}},[_vm._v(_vm._s(_vm.msg))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }